import React from "react";
import { observer } from "mobx-react";
import { ReactComponent as SaveTimeIcon } from "Assets/svg/linkedinTemplate/saveTimeIcon.svg";
import Button from "Components/common/Button";
import { linkedInTemplatePopupState } from "./LinkedInTemplatePopupState";

const LinkedInSequenceTemplatePopup = observer(() => {
  const { showPopup, setShowPopup, setShowTemplatesListPopup, manualCallback } = linkedInTemplatePopupState;

  if (!showPopup) return null;

  const handleManual = () => {
    setShowPopup(false);
    if (manualCallback) {
      manualCallback();
    }
  };

  const handleUseTemplate = () => {
    setShowPopup(false);
    setShowTemplatesListPopup(true);
    linkedInTemplatePopupState.fetchLinkedInTemplates();
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <div className="linkedinSequenceTemplatePopupSection">
      <div className="card animated customzoomIn">
        <div className="linkedinSequenceTemplatePopupContent">
          <div className="iconWrapper">
            <SaveTimeIcon />
          </div>
          <h2 className="title">Save time with a proven LinkedIn sequence?</h2>
          <p className="description">
            Start with a predefined LinkedIn sequence template. You can fully
            edit it before applying.
          </p>
        </div>
        <div className="linkedinSequenceTemplatePopupFooter">
          <Button
            btnText="Continue building manually"
            className="manualBtn"
            click={handleManual}
          />
          <Button
            btnText={linkedInTemplatePopupState.targetSequenceId ? "Use Template" : "Create and Customize"}
            className="templateBtn"
            click={handleUseTemplate}
          />
        </div>
      </div>
      <div className="overlayMaskPopup" onClick={handleClose}></div>
    </div>
  );
});

export { LinkedInSequenceTemplatePopup };
export default LinkedInSequenceTemplatePopup;

